var set = require('regenerate')();

set.addRange(0x10A80, 0x10A9F);
module.exports = set;